import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "actions",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "behaviour-actions" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
